import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { RegionService } from 'app/core/services/region.service';
import { Region } from 'app/shared/models/region';

@Injectable()
export class RegionsResolver implements Resolve<Region[]> {
  constructor(private regionService: RegionService, private router: Router) {}

  resolve(): Promise<any> {
    return this.regionService.getRegions().catch(error => {
      this.router.navigate(['/error']);
      return Promise.reject(error);
    });
  }
}
